function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.998,48c-0.681,0-1.366-0.229-1.928-0.702l-25-20.999C0.391,25.728,0,24.887,0,24 c0-0.886,0.391-1.727,1.07-2.296l25-21c1.269-1.066,3.161-0.902,4.227,0.367c1.065,1.269,0.901,3.161-0.368,4.227L7.664,24 l22.265,18.703c1.27,1.066,1.434,2.958,0.368,4.228C29.703,47.636,28.854,48,27.998,48"
});

var SvgIndietro = function SvgIndietro(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 49,
    viewBox: "-0.567 -0.486 32 49",
    enableBackground: "new -0.567 -0.486 32 49",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIndietro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indietro.5d728a4b.svg";
export { ForwardRef as ReactComponent };